/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Einvoice_Auto_IssuedInputs */

const vi_pos_einvoice_auto_issued = /** @type {(inputs: Pos_Einvoice_Auto_IssuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã phát hành hóa đơn tự động lên MISA.`)
};

/**

* @param {Pos_Einvoice_Auto_IssuedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_einvoice_auto_issued = /** @type {((inputs?: Pos_Einvoice_Auto_IssuedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Einvoice_Auto_IssuedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_einvoice_auto_issued(inputs)
});